export class UserActivity {
    constructor(userActivity) {
        this.id = userActivity.userId
        this.sessions = userActivity.sessions
    }
}

/**
* The constructor method is a special method of a 
* @class for creating and initializing an object instance of that 
* @class.
*/